import * as React from 'react';

import styles from './attachment-item.module.css';

interface Props {
  readonly filename: string;
  readonly amazonKey: string;
  readonly amazonId: string;
  readonly onClickPreview: (amazonId: string) => void;
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
}

export class AttachmentItem extends React.Component<Props> {
  render() {
    return (
      <div className={styles.container}>
        <div>
          <div className={styles.imageContainer}>
            <img className={`${styles.image} ${styles.link}`} alt="" 
                src={require('../../../../assets/images/file55x69.png')} 
                onClick={() => {
                  // Handle the non-serializable onClick logic independently
                  this.props.handleDownloadClick(this.props.amazonKey, this.props.filename);
                }} />
          </div>
          <div
            className={`${styles.filenameContainer} ${styles.link}`}
            onClick={() => {
              // Handle the non-serializable onClick logic independently
              this.props.handleDownloadClick(this.props.amazonKey, this.props.filename);
            }}
          >
            <span className={styles.filename}>{this.props.filename}</span>
          </div>
        </div>
      </div>
    );
  }
}
